export enum DOCUMENTOS_TYPES {
  // OTROS DOCUMENTOS - ASOCIADOS
  FORMDOCS_SET_ERRORS = 'FORMDOCS_SET_ERRORS',
  FORMDOCS_HANDLE_CHANGE = 'FORMDOCS_HANDLE_CHANGE',
  DATADOCS_SET_ASOCIADOS = 'DATADOCS_SET_ASOCIADOS',
  DATADOCS_RESET_MODULE = 'DATADOCS_RESET_MODULE',
  
  DOCS_FORMCLIENTE_HANDLE_CHANGE = 'DOCS_FORMCLIENTE_HANDLE_CHANGE',
  DOCS_FORMCLIENTE_SET_ERRORS = 'DOCS_FORMCLIENTE_SET_ERRORS',
  DOCS_FORMPRODUCTOS_HANDLE_CHANGE = 'DOCS_FORMPRODUCTOS_HANDLE_CHANGE',
  DOCS_FORMPRODUCTOS_SET_ERRORS = 'DOCS_FORMPRODUCTOS_SET_ERRORS',
  DOCS_FORMPRODUCTOS_HANDLE_CHANGE_EDIT = 'DOCS_FORMPRODUCTOS_HANDLE_CHANGE_EDIT',
  DOCS_FORMPRODUCTOS_SET_ERRORS_EDIT = 'DOCS_FORMPRODUCTOS_SET_ERRORS_EDIT',
  DOCS_FORMSUCURSAL_HANDLE_CHANGE = 'DOCS_FORMSUCURSAL_HANDLE_CHANGE',
  DOCS_FORMSUCURSAL_SET_ERRORS = 'DOCS_FORMSUCURSAL_SET_ERRORS',
  DOCS_FORMPRODUCTOS_CLEAR = 'DOCS_FORMPRODUCTOS_CLEAR',
  DOCS_ARRAYPRODUCTOS_ADD = 'DOCS_ARRAYPRODUCTOS_ADD',
  DOCS_ARRAYPRODUCTOS_EDIT = 'DOCS_ARRAYPRODUCTOS_EDIT',
  DOCS_ARRAYPRODUCTOS_SET_CALCULOS = 'DOCS_ARRAYPRODUCTOS_SET_CALCULOS',
  DOCS_ARRAYPRODUCTOS_CLEAR_ALL = 'DOCS_ARRAYPRODUCTOS_CLEAR_ALL',
  DOCS_ARRAYPRODUCTOS_SELECT_ONE = 'DOCS_ARRAYPRODUCTOS_SELECT_ONE',
  DOCS_ARRAYPRODUCTOS_DELETE_ONE = 'DOCS_ARRAYPRODUCTOS_DELETE_ONE',
  DOCS_FACTURACION_CLEAR_ALL = 'DOCS_FACTURACION_CLEAR_ALL',
  DOCS_SET_DATOS_EMISOR = 'DOCS_SET_DATOS_EMISOR',
  DOCS_SET_DATOS_FACTURA = 'DOCS_SET_DATOS_FACTURA',
  DOCS_FACTURA_EMITIDA = 'DOCS_FACTURA_EMITIDA',
  DOCS_OPCIONES_ACTIVA = 'DOCS_OPCIONES_ACTIVA',
  DOCS_SET_CATALOGO_SUCURSAL = 'DOCS_SET_CATALOGO_SUCURSAL',
  DOCS_SET_CATALOGO_SERIE = 'DOCS_SET_CATALOGO_SERIE',
  DOCS_SET_UUID = 'DOCS_SET_UUID',
  DOCS_ACTIVE_MODULE = 'DOCS_ACTIVE_MODULE',
  
  // MODALS
  DOCS_MODALELIMINAR_OPEN = 'DOCS_MODALELIMINAR_OPEN',
  DOCS_MODALELIMINAR_CLOSE = 'DOCS_MODALELIMINAR_CLOSE',
  DOCS_MODALEDITAR_OPEN = 'DOCS_MODALEDITAR_OPEN',
  DOCS_MODALEDITAR_CLOSE = 'DOCS_MODALEDITAR_CLOSE',
  DOCS_MODALFACTURACION_OPEN = 'DOCS_MODALFACTURACION_OPEN',
  DOCS_MODALIMPRESION_OPEN = 'DOCS_MODALIMPRESION_OPEN',
  DOCS_MODALEMAIL_OPEN = 'DOCS_MODALEMAIL_OPEN',
  DOCS_MODALANULAR_OPEN = 'DOCS_MODALANULAR_OPEN',

  // DATOS RECEPTOR
  DOCS_RECEPTOR_HANDLE_CHANGE = "DOCS_RECEPTOR_HANDLE_CHANGE",
  DOCS_RECEPTOR_SET_ERRORS = "DOCS_RECEPTOR_SET_ERRORS",
  DOCS_RECEPTOR_RESET_MODULE = 'DATADOCS_RESET_MODULE',
  DOCS_RECEPTOR_HISTORIAL_HANDLE_CHANGE = "DOCS_RECEPTOR_HISTORIAL_HANDLE_CHANGE",
}
